export const slugsPart4 = {
    "K3s": "k3s",
    "k6": "k6",
    "Kaggle": "kaggle",
    "Kagi": "kagi",
    "Kahoot!": "kahoot",
    "KaiOS": "kaios",
    "Kakao": "kakao",
    "KakaoTalk": "kakaotalk",
    "Kali Linux": "kalilinux",
    "Kamailio": "kamailio",
    "Kando": "kando",
    "Kaniko": "kaniko",
    "Karlsruher Verkehrsverbund": "karlsruherverkehrsverbund",
    "Kasa Smart": "kasasmart",
    "KashFlow": "kashflow",
    "Kaspersky": "kaspersky",
    "Katana": "katana",
    "Kaufland": "kaufland",
    "KDE": "kde",
    "KDE neon": "kdeneon",
    "KDE Plasma": "kdeplasma",
    "Kdenlive": "kdenlive",
    "Kedro": "kedro",
    "Keenetic": "keenetic",
    "Keep a Changelog": "keepachangelog",
    "KeePassXC": "keepassxc",
    "Keeper": "keeper",
    "KeeWeb": "keeweb",
    "Kenmei": "kenmei",
    "Kentico": "kentico",
    "Keploy": "keploy",
    "Keras": "keras",
    "Keybase": "keybase",
    "KeyCDN": "keycdn",
    "Keycloak": "keycloak",
    "Keystone": "keystone",
    "KFC": "kfc",
    "Khan Academy": "khanacademy",
    "Khronos Group": "khronosgroup",
    "Kia": "kia",
    "Kibana": "kibana",
    "KiCad": "kicad",
    "Kick": "kick",
    "Kickstarter": "kickstarter",
    "Kik": "kik",
    "Kingston Technology": "kingstontechnology",
    "Kinopoisk": "kinopoisk",
    "Kinsta": "kinsta",
    "Kirby": "kirby",
    "Kit": "kit",
    "Kitsu": "kitsu",
    "Kiwix": "kiwix",
    "Klarna": "klarna",
    "Kleinanzeigen": "kleinanzeigen",
    "KLM": "klm",
    "Klook": "klook",
    "Knative": "knative",
    "Knex.js": "knexdotjs",
    "KNIME": "knime",
    "Knip": "knip",
    "KnowledgeBase": "knowledgebase",
    "Known": "known",
    "Ko-fi": "kofi",
    "Koa": "koa",
    "Koc": "koc",
    "Kodak": "kodak",
    "Kodi": "kodi",
    "Koenigsegg": "koenigsegg",
    "Kofax": "kofax",
    "Komoot": "komoot",
    "Konami": "konami",
    "Kong": "kong",
    "Kongregate": "kongregate",
    "Konva": "konva",
    "KOReader": "koreader",
    "Kotlin": "kotlin",
    "Koyeb": "koyeb",
    "Kred": "kred",
    "Krita": "krita",
    "KTM": "ktm",
    "Ktor": "ktor",
    "Kuaishou": "kuaishou",
    "Kubernetes": "kubernetes",
    "Kubespray": "kubespray",
    "Kubuntu": "kubuntu",
    "KuCoin": "kucoin",
    "Kueski": "kueski",
    "Kuma": "kuma",
    "Kununu": "kununu",
    "Kuula": "kuula",
    "KX": "kx",
    "Kyocera": "kyocera",
    "L'Équipe": "lequipe",
    "LabEx": "labex",
    "LabVIEW": "labview",
    "LADA": "lada",
    "Lamborghini": "lamborghini",
    "LangChain": "langchain",
    "Langflow": "langflow",
    "LangGraph": "langgraph",
    "LanguageTool": "languagetool",
    "Lapce": "lapce",
    "Laragon": "laragon",
    "Laravel": "laravel",
    "Laravel Horizon": "laravelhorizon",
    "Laravel Nova": "laravelnova",
    "Last.fm": "lastdotfm",
    "LastPass": "lastpass",
    "LaTeX": "latex",
    "Launchpad": "launchpad",
    "Lazarus": "lazarus",
    "LazyVim": "lazyvim",
    "LBRY": "lbry",
    "Leader Price": "leaderprice",
    "Leaflet": "leaflet",
    "League of Legends": "leagueoflegends",
    "Leanpub": "leanpub",
    "LeetCode": "leetcode",
    "Lefthook": "lefthook",
    "Legacy Games": "legacygames",
    "Leica": "leica",
    "Lemmy": "lemmy",
    "Lemon Squeezy": "lemonsqueezy",
    "Lenovo": "lenovo",
    "Lens": "lens",
    "Leptos": "leptos",
    "Lerna": "lerna",
    "Leroy Merlin": "leroymerlin",
    "Les libraires": "leslibraires",
    "Less": "less",
    "Let's Encrypt": "letsencrypt",
    "Letterboxd": "letterboxd",
    "levels.fyi": "levelsdotfyi",
    "LG": "lg",
    "Li-Ning": "lining",
    "Libera.Chat": "liberadotchat",
    "Liberapay": "liberapay",
    "Libraries.io": "librariesdotio",
    "LibraryThing": "librarything",
    "LibreOffice": "libreoffice",
    "LibreOffice Base": "libreofficebase",
    "LibreOffice Calc": "libreofficecalc",
    "LibreOffice Draw": "libreofficedraw",
    "LibreOffice Impress": "libreofficeimpress",
    "LibreOffice Math": "libreofficemath",
    "LibreOffice Writer": "libreofficewriter",
    "LibreTranslate": "libretranslate",
    "LibreTube": "libretube",
    "LibreWolf": "librewolf",
    "libuv": "libuv",
    "Lichess": "lichess",
    "Lidl": "lidl",
    "LIFX": "lifx",
    "LightBurn": "lightburn",
    "Lighthouse": "lighthouse",
    "Lightning": "lightning",
    "LimeSurvey": "limesurvey",
    "LINE": "line",
    "LineageOS": "lineageos",
    "Linear": "linear",
    "Linkerd": "linkerd",
    "Linkfire": "linkfire",
    "Linksys": "linksys",
    "Linktree": "linktree",
    "Linphone": "linphone",
    "LintCode": "lintcode",
    "Linux": "linux",
    "Linux Containers": "linuxcontainers",
    "Linux Foundation": "linuxfoundation",
    "Linux Mint": "linuxmint",
    "Linux Professional Institute": "linuxprofessionalinstitute",
    "LinuxServer": "linuxserver",
    "Lion Air": "lionair",
    "Liquibase": "liquibase",
    "ListenHub": "listenhub",
    "listmonk": "listmonk",
    "Lit": "lit",
    "Litecoin": "litecoin",
    "Literal": "literal",
    "LITIENGINE": "litiengine",
    "LiveChat": "livechat",
    "LiveJournal": "livejournal",
    "LiveKit": "livekit",
    "Livewire": "livewire",
    "LLVM": "llvm",
    "LMMS": "lmms",
    "Lobsters": "lobsters",
    "Local": "local",
    "LocalSend": "localsend",
    "LocalXpose": "localxpose",
    "Lodash": "lodash",
    "LogMeIn": "logmein",
    "Logseq": "logseq",
    "Logstash": "logstash",
    "Looker": "looker",
    "Loom": "loom",
    "Loop": "loop",
    "LoopBack": "loopback",
    "Loot Crate": "lootcrate",
    "Lospec": "lospec",
    "LOT Polish Airlines": "lotpolishairlines",
    "LottieFiles": "lottiefiles",
    "LTspice": "ltspice",
    "Lua": "lua",
    "Luanti": "luanti",
    "Luau": "luau",
    "Lubuntu": "lubuntu",
    "Lucia": "lucia",
    "Lucid": "lucid",
    "Lucide": "lucide",
    "Ludwig": "ludwig",
    "Lufthansa": "lufthansa",
    "Lumen": "lumen",
    "Lunacy": "lunacy",
    "Luogu": "luogu",
    "Lutris": "lutris",
    "LVGL": "lvgl",
    "Lydia": "lydia",
    "Lyft": "lyft",
    "MAAS": "maas",
    "macOS": "macos",
    "MacPaw": "macpaw",
    "MacPorts": "macports",
    "Macy's": "macys",
    "Magasins U": "magasinsu",
    "Magic": "magic",
    "Magisk": "magisk",
    "Mahindra": "mahindra",
    "mail.com": "maildotcom",
    "Mail.Ru": "maildotru",
    "mailbox": "mailbox",
    "MailChimp": "mailchimp",
    "Mailgun": "mailgun",
    "Mailtrap": "mailtrap",
    "MainWP": "mainwp",
    "Major League Hacking": "majorleaguehacking",
    "Make": "make",
    "MakerBot": "makerbot",
    "Malt": "malt",
    "Malwarebytes": "malwarebytes",
    "Mamba UI": "mambaui",
    "MAMP": "mamp",
    "MAN": "man",
    "ManageIQ": "manageiq",
    "Mangacollec": "mangacollec",
    "MangaUpdates": "mangaupdates",
    "Manjaro": "manjaro",
    "Mantine": "mantine",
    "Mapbox": "mapbox",
    "Mapillary": "mapillary",
    "MapLibre": "maplibre",
    "MapTiler": "maptiler",
    "MariaDB": "mariadb",
    "MariaDB Foundation": "mariadbfoundation",
    "Markdown": "markdown",
    "Marko": "marko",
    "Marriott": "marriott",
    "MarvelApp": "marvelapp",
    "Maserati": "maserati",
    "MasterCard": "mastercard",
    "mastercomfig": "mastercomfig",
    "Mastodon": "mastodon",
    "Material Design": "materialdesign",
    "Material Design Icons": "materialdesignicons",
    "Material for MkDocs": "materialformkdocs",
    "Matillion": "matillion",
    "Matomo": "matomo",
    "Matrix": "matrix",
    "Matter.js": "matterdotjs",
    "Mattermost": "mattermost",
    "Matternet": "matternet",
    "Mautic": "mautic",
    "Max": "max",
    "Max-Planck-Gesellschaft": "maxplanckgesellschaft",
    "Maytag": "maytag",
    "Mazda": "mazda",
    "Maze": "maze",
    "McAfee": "mcafee",
    "McDonald's": "mcdonalds",
    "McLaren": "mclaren",
    "MDBList": "mdblist",
    "mdBook": "mdbook",
    "MDN Web Docs": "mdnwebdocs",
    "MDX": "mdx",
    "Mealie": "mealie",
    "MediaFire": "mediafire",
    "MediaMarkt": "mediamarkt",
    "MediaPipe": "mediapipe",
    "MediaTek": "mediatek",
    "MediBang Paint": "medibangpaint",
    "Medium": "medium",
    "Medusa": "medusa",
    "Meetup": "meetup",
    "MEGA": "mega",
    "Meilisearch": "meilisearch",
    "Meituan": "meituan",
    "Meizu": "meizu",
    "Mendeley": "mendeley",
    "MentorCruise": "mentorcruise",
    "Mercado Pago": "mercadopago",
    "Merck": "merck",
    "Mercurial": "mercurial",
    "Mermaid": "mermaid",
    "Messenger": "messenger",
    "Meta": "meta",
    "Metabase": "metabase",
    "Metacritic": "metacritic",
    "MetaFilter": "metafilter",
    "MetaGer": "metager",
    "Metasploit": "metasploit",
    "Meteor": "meteor",
    "Metro": "metro",
    "Metro de la Ciudad de México": "metrodelaciudaddemexico",
    "Metro de Madrid": "metrodemadrid",
    "Métro de Paris": "metrodeparis",
    "MeWe": "mewe",
    "Mezmo": "mezmo",
    "MG": "mg",
    "Micro Editor": "microeditor",
    "micro:bit": "microbit",
    "Micro.blog": "microdotblog",
    "MicroPython": "micropython",
    "Microstation": "microstation",
    "MicroStrategy": "microstrategy",
    "MIDI": "midi",
    "Migadu": "migadu",
    "Mihon": "mihon",
    "miHoYo": "mihoyo",
    "MikroTik": "mikrotik",
    "Milanote": "milanote",
    "Milvus": "milvus",
    "Minds": "minds",
    "MinGW-w64": "mingww64",
    "Mini": "mini",
    "MiniMax": "minimax",
    "MinIO": "minio",
    "Mintlify": "mintlify",
    "Minutemailer": "minutemailer",
    "Miraheze": "miraheze",
    "Miro": "miro",
    "Misskey": "misskey",
    "Mistral AI": "mistralai",
    "Mitsubishi": "mitsubishi",
    "Mix": "mix",
    "Mixcloud": "mixcloud",
    "Mixpanel": "mixpanel",
    "MLB": "mlb",
    "MLflow": "mlflow",
    "MobX": "mobx",
    "MobX-State-Tree": "mobxstatetree",
    "Mocha": "mocha",
    "Mock Service Worker": "mockserviceworker",
    "Modal": "modal",
    "Model Context Protocol": "modelcontextprotocol",
    "ModelScope": "modelscope",
    "Modin": "modin",
    "Modrinth": "modrinth",
    "MODX": "modx",
    "Mojeek": "mojeek",
    "Moleculer": "moleculer",
    "Momenteo": "momenteo",
    "Monero": "monero",
    "MoneyGram": "moneygram",
    "MongoDB": "mongodb",
    "Mongoose": "mongoose",
    "Mongoose (Server)": "mongoosedotws",
    "Monica": "monica",
    "monkey tie": "monkeytie",
    "Monkeytype": "monkeytype",
    "MonoGame": "monogame",
    "Monoprix": "monoprix",
    "Monster": "monster",
    "Monzo": "monzo",
    "Moo": "moo",
    "Moodle": "moodle",
    "Moonrepo": "moonrepo",
    "Moq": "moq",
    "Moqups": "moqups",
    "Morrisons": "morrisons",
    "Moscow Metro": "moscowmetro",
    "Motorola": "motorola",
    "Movistar": "movistar",
    "Mozilla": "mozilla",
    "mpv": "mpv",
    "MQTT": "mqtt",
    "MSI": "msi",
    "MSI Business": "msibusiness",
    "MTA": "mta",
    "MTR": "mtr",
    "MUBI": "mubi",
    "MUI": "mui",
    "Müller": "muller",
    "Mullvad": "mullvad",
    "Multisim": "multisim",
    "Mumble": "mumble",
    "MUO": "muo",
    "Mural": "mural",
    "MusicBrainz": "musicbrainz",
    "MX Linux": "mxlinux",
    "MyAnimeList": "myanimelist",
    "MyGet": "myget",
    "MYOB": "myob",
    "MyShows": "myshows",
    "Myspace": "myspace",
    "MySQL": "mysql",
    "N26": "n26",
    "n8n": "n8n",
    "Namebase": "namebase",
    "Namecheap": "namecheap",
    "NameMC": "namemc",
    "NameSilo": "namesilo",
    "Namu Wiki": "namuwiki",
    "Nano": "nano",
    "Nano Stores": "nanostores",
    "Napster": "napster",
    "NASA": "nasa",
    "National Grid": "nationalgrid",
    "National Rail": "nationalrail",
    "NativeScript": "nativescript",
    "NATS.io": "natsdotio",
    "Naver": "naver",
    "NBA": "nba",
    "NBB": "nbb",
    "NBC": "nbc",
    "NDR": "ndr",
    "NEAR": "near",
    "Nebula": "nebula",
    "NEC": "nec",
    "Nederlandse Spoorwegen": "nederlandsespoorwegen",
    "Neo4j": "neo4j",
    "Neovim": "neovim",
    "Neptune": "neptune",
    "NestJS": "nestjs",
    "NetApp": "netapp",
    "NetBSD": "netbsd",
    "netcup": "netcup",
    "Netdata": "netdata",
    "NetEase Cloud Music": "neteasecloudmusic",
    "Netflix": "netflix",
    "NETGEAR": "netgear",
    "Netim": "netim",
    "Netlify": "netlify",
    "Nette": "nette",
    "Netto": "netto",
    "Neutralinojs": "neutralinojs",
    "New Balance": "newbalance",
    "New Japan Pro-Wrestling": "newjapanprowrestling",
    "New Relic": "newrelic",
    "New York Times": "newyorktimes",
    "Newegg": "newegg",
    "Newgrounds": "newgrounds",
    "NewPipe": "newpipe",
    "NEXON": "nexon",
    "Next.js": "nextdotjs",
    "nextbike": "nextbike",
    "NextBillion.ai": "nextbilliondotai",
    "Nextcloud": "nextcloud",
    "NextDNS": "nextdns",
    "Nextdoor": "nextdoor",
    "Nextflow": "nextflow",
    "Nextra": "nextra",
    "nf-core": "nfcore",
    "NFC": "nfc",
    "NGINX": "nginx",
    "Nginx Proxy Manager": "nginxproxymanager",
    "ngrok": "ngrok",
    "NgRx": "ngrx",
    "NHL": "nhl",
    "Nhost": "nhost",
    "NiceHash": "nicehash",
    "niconico": "niconico",
    "Nike": "nike",
    "Nikon": "nikon",
    "Nim": "nim",
    "niri": "niri",
    "Nissan": "nissan",
    "NixOS": "nixos",
    "Nobara Linux": "nobaralinux",
    "Node-RED": "nodered",
    "Node.js": "nodedotjs",
    "NodeBB": "nodebb",
    "NodeGui": "nodegui",
    "Nodemon": "nodemon",
    "Nokia": "nokia",
    "Nomad": "nomad",
    "Norco": "norco",
    "Nordic Semiconductor": "nordicsemiconductor",
    "NordVPN": "nordvpn",
    "Normalize.css": "normalizedotcss",
    "Norton": "norton",
    "Norwegian": "norwegian",
    "Note": "note",
    "NotebookLM": "notebooklm",
    "Notepad++": "notepadplusplus",
    "Notion": "notion",
    "Notist": "notist",
    "Noun Project": "nounproject",
    "Novu": "novu",
    "NOW": "now",
    "npm": "npm",
    "Nrwl": "nrwl",
    "NSIS": "nsis",
    "ntfy": "ntfy",
    "Nubank": "nubank",
    "Nucleo": "nucleo",
    "NuGet": "nuget",
    "Nuke": "nuke",
    "Numba": "numba",
    "NumPy": "numpy",
    "Nunjucks": "nunjucks",
    "Nushell": "nushell",
    "Nutanix": "nutanix",
    "Nuxt": "nuxt",
    "NVIDIA": "nvidia",
    "nvm": "nvm",
    "Nx": "nx",
    "NXP": "nxp",
    "NZXT": "nzxt",
    "O'Reilly": "oreilly",
    "O2": "o2",
    "ÖBB": "obb",
    "OBS Studio": "obsstudio",
    "Observable": "observable",
    "Obsidian": "obsidian",
    "Obtainium": "obtainium",
    "OCaml": "ocaml",
    "OCLC": "oclc",
    "oclif": "oclif",
    "Octane Render": "octanerender",
    "Octave": "octave",
    "October CMS": "octobercms",
    "OctoPrint": "octoprint",
    "Octopus Deploy": "octopusdeploy",
    "Oculus": "oculus",
    "Odido": "odido",
    "Odin": "odin",
    "Odnoklassniki": "odnoklassniki",
    "Odoo": "odoo",
    "Odysee": "odysee",
    "Oh Dear": "ohdear",
    "okcupid": "okcupid",
    "Okta": "okta",
    "OKX": "okx",
    "Ollama": "ollama",
    "Omada Cloud": "omadacloud",
    "Omarchy": "omarchy",
    "OnePlus": "oneplus",
    "OneStream": "onestream",
    "OnlyFans": "onlyfans",
    "ONLYOFFICE": "onlyoffice",
    "ONNX": "onnx",
    "OnStar": "onstar",
    "Opel": "opel",
    "Open Access": "openaccess",
    "Open Badges": "openbadges",
    "Open Bug Bounty": "openbugbounty",
    "Open Collective": "opencollective",
    "Open Containers Initiative": "opencontainersinitiative",
    "Open Source Hardware": "opensourcehardware",
    "Open Source Initiative": "opensourceinitiative",
    "Open3D": "open3d",
    "OpenAI Gym": "openaigym",
    "OpenAPI Initiative": "openapiinitiative",
    "OpenBSD": "openbsd",
    "OpenCage": "opencage",
    "OpenCritic": "opencritic",
    "OpenCV": "opencv",
    "OpenFaaS": "openfaas",
    "OpenGL": "opengl",
    "openHAB": "openhab",
    "OpenID": "openid",
    "OpenJDK": "openjdk",
    "OpenJS Foundation": "openjsfoundation",
    "Openlayers": "openlayers",
    "openmediavault": "openmediavault",
    "OpenMined": "openmined",
    "OpenNebula": "opennebula",
    "OpenProject": "openproject",
    "OpenRouter": "openrouter",
    "OpenSCAD": "openscad",
    "OpenSea": "opensea",
    "OpenSearch": "opensearch",
    "OpenSSL": "openssl",
    "OpenStack": "openstack",
    "OpenStreetMap": "openstreetmap",
    "openSUSE": "opensuse",
    "OpenTelemetry": "opentelemetry",
    "OpenText": "opentext",
    "OpenTofu": "opentofu",
    "Openverse": "openverse",
    "OpenVPN": "openvpn",
    "OpenWrt": "openwrt",
    "OpenZeppelin": "openzeppelin",
    "OpenZFS": "openzfs",
    "Opera": "opera",
    "Opera GX": "operagx",
    "OPNsense": "opnsense",
    "OPPO": "oppo",
    "Opsgenie": "opsgenie",
    "OpsLevel": "opslevel",
    "Optimism": "optimism",
    "Optuna": "optuna",
    "Orange": "orange",
    "ORCID": "orcid",
    "Org": "org",
    "Organic Maps": "organicmaps",
    "Origin": "origin",
    "Osano": "osano",
    "OSF": "osf",
    "OSGeo": "osgeo",
    "Oshkosh": "oshkosh",
    "OsmAnd": "osmand",
    "OSMC": "osmc",
    "osu!": "osu",
    "Otto": "otto",
    "Outline": "outline",
    "Overcast": "overcast",
    "Overleaf": "overleaf",
    "OVH": "ovh",
    "OWASP": "owasp",
    "OWASP Dependency-Check": "dependencycheck",
    "ownCloud": "owncloud",
    "Oxc": "oxc",
    "Oxygen": "oxygen",
    "OYO": "oyo",
};
